export const allocationBy = [
  { name: "Model", value: "version" },
  { name: "Company", value: "company" },
  { name: "Customized", value: "customized" },
];

export const currentAllocation = [
  {
    name: "Allocated",
    value: "allocated",
    subText:
      "This shows the target weight of each asset in your portfolio at creation or last rebalance.",
  },
  {
    name: "Current",
    value: "current",
    subText:
      "This shows the current asset distribution in your portfolio, reflecting market value changes.",
  },
];

export const rebalanceUsing = [
  {
    name: "Current Value",
    value: "current",
    allocationType: ["rebalance", "allocation", "exit"],
    rebalance: ["company", "version", "customized"],
    allocation: ["company"],
    exit: ["companyWeightage"],
    subText:
      "Current value refers to the total present holding value of the portfolio, this option will create orders in order to achieve the specified weightage for the company(selected in the next step) w.r.t the current holdings of the portfolio.",
  },
  {
    name: "Portfolio Value",
    value: "portfolio",
    allocationType: ["rebalance", "allocation", "exit"],
    rebalance: ["company", "version", "customized"],
    allocation: ["company"],
    exit: ["companyWeightage"],
    subText:
      "Portfolio value refers to the total present holding value of the portfolio plus the available ledger balance, this option will create orders in order to achieve the specified weightage for the company(selected in the next step) w.r.t the portfolio value of the portfolio.",
  },
  {
    name: "Portfolio Value - Absolute",
    value: "portfolioAbsolute",
    allocationType: ["allocation"],
    rebalance: [] as string[],
    allocation: ["company"],
    subText:
      "Portfolio value refers to the total present holding value of the portfolio plus the available ledger balance, this option will create orders in order to achieve the specified weightage for the company(selected in the next step) w.r.t the portfolio value of the portfolio.",
  },
  {
    name: "Current Value - Absolute",
    value: "currentAbsolute ",
    allocationType: ["allocation"],
    rebalance: [],
    allocation: ["company"],
    subText:
      "The capital that the client has agreed to invest in a given portfolio, this option will also consider the existing holdings of the asset while creating the orders.",
  },
  {
    name: "Committed Value",
    value: "committedValue",
    allocationType: ["rebalance", "allocation", "exit"],
    rebalance: ["company", "version"],
    allocation: ["company", "version"],
    exit: ["companyWeightage"],
    subText:
      "The capital that the client has agreed to invest in a given portfolio, this option will also consider the existing holdings of the asset while creating the orders.",
  },
  {
    name: "Committed Value - Absolute",
    value: "commitedValueAbsolute",
    allocationType: ["allocation"],
    rebalance: [],
    allocation: ["version", "company"],
    subText:
      "This option will not consider the existing holdings of the asset while creating the orders, it will straight away allocate funds on the basis of the total committed value.",
  },
  {
    name: "Ledger Balance",
    value: "ledgerBalance",
    allocationType: ["allocation"],
    rebalance: [],
    allocation: ["company", "version"],
    subText:
      "This option will use the available ledger balance to allocate funds while creating orders.",
  },
];

export const allocationExitBy = [
  {
    name: "Model",
    disabled: false,
    value: "version",
  },
  {
    name: "Portfolio",
    disabled: false,
    value: "portfolio",
  },
  {
    name: "Company-Absolute",
    disabled: false,
    value: "company",
  },
  {
    name: "Company-Weightage",
    disabled: false,
    value: "companyWeightage",
  },
];

export const weightageDistributionMethod = [
  {
    name: "Prorata",
    value: "PRORATA",
    subText:
      "Selecting this option will redistribute the hold amount into the other assets being bought in a prorata basis according to the allocation weightages.",
  },
  {
    name: "No Redistribution",
    value: "FIXED",
    subText:
      "Selecting this option will not redistribute the hold amount into other assets and add this amount to the ledger balance.",
  },
];

export const rebalanceCustomParameter = [
  { value: "companyAbsolute", name: "Company-Absolute" },
  { value: "companyFinal", name: "Company-Final Weightage" },
  { value: "weightageWise", name: "Weightage of CV/PV" },
];
